(ns app.front.view.language-picker
  (:require [app.front.ui.locale-select :as ui-locale-select]
            [core.front.event :refer [<sub >evt]]
            [core.front.i18n :as i18n]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub
  ::selected-lang :-> :language)



;;
;; Compact pickers for new login page
;;

(defn compact-language-picker
  "Compact language picker with smaller size."
  []
  (let [languages (<sub [::i18n/locales])
        selected  (<sub [::selected-lang])
        tr        (<sub [:tr])]
    [ui-locale-select/locale-select
     {:value     (some-> selected name)
      :label     (tr [:login-new/language])
      :align     "end"
      :on-change #(>evt [::i18n/change-language (keyword %)])
      :options   (map (fn [[code lang]]
                        {:value         (name code)
                         :label         (str (:name lang) " (" (:short-name lang) ")")
                         :trigger-label (:name lang)})
                      languages)}]))
